/* Pradawne Dary: „Kup teraz” — dodaje do koszyka zawartość formularza produktu i przechodzi do kasy. */
(() => {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ab-buy-now]');
    if (!btn || btn.disabled) return;
    const form = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('loading');
    btn.querySelector('.loading__spinner')?.classList.remove('hidden');
    try {
      const data = new FormData(form);
      if (!data.get('quantity')) data.set('quantity', '1');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'add failed');
      }
      window.location.href = `${root}checkout`;
    } catch (err) {
      btn.disabled = false;
      btn.classList.remove('loading');
      btn.querySelector('.loading__spinner')?.classList.add('hidden');
      const box = form.closest('product-form')?.querySelector('.product-form__error-message');
      const wrap = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      if (box && wrap) {
        box.textContent = err.message;
        wrap.hidden = false;
      } else {
        window.alert(err.message);
      }
    }
  });
})();
